import {Dispatch} from '@reduxjs/toolkit'
import {
  GetPackages,
  setConfirmPayModal,
  setPackageModalOpen
} from 'entities/payment'

type upgradeHandlerProps = {
  dispatch: Dispatch
  paymentsCount: number
}

export const upgradeHandler = ({dispatch, paymentsCount}: upgradeHandlerProps) => {
  if (paymentsCount > 0) return dispatch(setPackageModalOpen(true))

  GetPackages()
    .then(({data}) => {
      if (!data.data.length) return
      return dispatch(setConfirmPayModal({isOpen: true, ...data.data[0]}))
    })
    .catch(console.error)
}
